// extracted by mini-css-extract-plugin
export default {"anchor":"PunchupHelpButton_anchor__Cz1pL"};